const handleNotion = () => {
  $('.main').css('padding-top', $('.header').outerHeight());
}

handleNotion();
